// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","breadcrumb":"breadcrumb-UT1Ua"};